import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import GLOBAL from 'jcolorglobal';
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";
import TimeFormat from 'components/commons/TimeFormat';
import Dropdown from 'components/commons/Dropdown';

import MoreIcon from 'react-icons/lib/md/keyboard-control';

class InvoiceListItem extends PureComponent {

    static propTypes = {
        item: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.renderMenu = this.renderMenu.bind(this);
    }

    getStatusText(status){

        switch(Number(status)){
            case 1: return '捐贈';
            case 2: return '未寄出';
            case 3: return '中獎未寄出';
            case 4: return '已寄出';
            default: return '';
        }
    }

    getFailStatusText(status){

        switch(Number(status)){
            case 0: return '開立';
            case 1: return '作廢';
            case 2: return '折讓';
            default: return '開立';   
        }
    }

    getTurnkeyStatusText(turnkeyupcasttime){
        if(!turnkeyupcasttime)
            return '未上傳';
        switch(Number(turnkeyupcasttime)){
            case undefined:
            case -1: return '未上傳';
            case -2: return '失敗';
            default: return '已上傳';   
        }

    }

    failInvoice(item) {

        this.props.failInvoice && this.props.failInvoice(item);
    }


    dnldInvoice(item) {

        this.props.dnldInvoice && this.props.dnldInvoice(item);

        const detail = item.detail;

        var istatus;

        if(detail) {
            istatus = Number(detail.istatus);
        }

        if(istatus === 2 || istatus === 3) {
            this.setInvoiceSent(item);
        }
    }

    setInvoiceSent(item) {

        this.props.setInvoiceSent && this.props.setInvoiceSent(item)
    }

    renderMenu(item) {

        const detail = item.detail;

        var ifailstatus;
        var istatus;
        
        if(detail) {
            ifailstatus = Number(detail.ifailstatus);
            istatus = Number(detail.istatus);
        }

        return (
            <ul>
                <li onClick={(event) => this.dnldInvoice(item)}><a>下載</a></li>
                {item.turnkeyupcasttime < 0 ?
                    <li>
                        <CupoySrefView 
                            statename={CupoyRouter.STATES.EDIT_INVOICE}
                            params={{
                                yearmonth: item.yearmonth,
                                istarttag: item.istarttag,
                                invoicenumber: item.invoicenumber,
                            }}
                        >
                            編輯
                        </CupoySrefView>
                    </li>
                    :
                    null
                }
                {!ifailstatus || ifailstatus === 0 ?
                    <li>
                        <CupoySrefView 
                            statename={CupoyRouter.STATES.CREATE_ALLOWANCE}
                            params={{
                                yearmonth: item.yearmonth,
                                istarttag: item.istarttag,
                                invoicenumber: item.invoicenumber,
                            }}
                        >
                            折讓
                        </CupoySrefView>
                    </li>
                    :
                    null
                }

                {istatus === 2 || istatus === 3 ?
                    <li onClick={(event) => this.setInvoiceSent(item)}><a>設為已寄出</a></li>
                    :
                    null
                }
                {!ifailstatus || ifailstatus === 0 ?
                    <li onClick={(event) => this.failInvoice(item)}><a>作廢</a></li>
                    :
                    null
                }

            </ul>
        )
    }

    render() {
        const {
            item,
        } = this.props;
        
        const istatus = this.getStatusText(item.detail.istatus);
        const failstatus = this.getFailStatusText(item.detail.ifailstatus);
        const turnkeystatus = this.getTurnkeyStatusText(item.turnkeyupcasttime);
        const isTriCopy = item.detail.buyerinfo && item.detail.buyerinfo.buyercrn && item.detail.buyerinfo.buyercrn !== GLOBAL.DEFAULT_BUYERCRN;
        
        var salesamount = item.detail.salesamount;
        var salestax = item.detail.salestax;

        // 二聯式發票因為 item.detail.salesamount 為含稅價，salestax 為 0，但列表還是要呈現未稅含稅價，因此直接除1.05
        if(!isTriCopy) {
            salesamount = Math.round(salesamount / 1.05);
            // 驗證是否正確
            var check = Math.round(salesamount * 1.05) - item.detail.salesamount;
            if(check > 0) {
                salesamount -= 1;
            } else if(check < 0) {
                salesamount += 1;
            }

            salestax = item.detail.salesamount - salesamount;
        }

        return (            
            <tr className="table-list-row">
                <td className="table-list-col link" style={{width: '100px'}}>
                    <CupoySrefView
                        statename={CupoyRouter.STATES.INVOICE_INFO}
                        params={{
                            yearmonth: item.yearmonth,
                            istarttag: item.istarttag,
                            invoicenumber: item.invoicenumber,
                        }}
                    >
                        {item.istarttag}-{item.invoicenumber}
                    </CupoySrefView>
                </td>
                <td className="table-list-col" style={{width: '70px'}}>
                    {item.yearmonth}
                </td>                
                <td className="table-list-col" style={{width: '80px'}}>
                    <TimeFormat
                        format="shortDate"
                        time={item.receipttime}
                    />
                </td>
                <td className="table-list-col" style={{width: '140px'}}>
                    {item.orderid}
                </td>               
                <td className="table-list-col center" style={{width: '70px'}}>
                    {salesamount}
                </td>   
                <td className="table-list-col center" style={{width: '70px'}}>
                    {salestax}
                </td>
                <td className="table-list-col center" style={{width: '70px'}}>
                    {salesamount + salestax}
                </td>         
                <td className="table-list-col">
                    {item.detail.buyerinfo ? item.detail.buyerinfo.buyername : ''}
                </td>
                <td className="table-list-col" style={{width: '80px'}}>
                    {isTriCopy && item.detail.buyerinfo ? item.detail.buyerinfo.buyercrn : '-'}
                </td>                                                                 
                <td className="table-list-col" >
                    {failstatus}
                </td>
                <td className="table-list-col" >
                    {istatus}
                </td>
                <td className="table-list-col" >
                    {turnkeystatus}
                </td>                
                <Dropdown
                    defaultVisible={false}
                    overlay={this.renderMenu(item)}
                    trigger={['click']}
                    placement="bottomRight"
                    overlayClassName="dropdown popup open"
                    overlayStyle={{ position: 'absolute' }}
                    zIndex={2000}
                >
                    <td className="table-list-col center action" style={{width: '40px'}}>
                        <MoreIcon/>
                    </td>
                </Dropdown>
            </tr>
        );
    }
}

export default InvoiceListItem;



// WEBPACK FOOTER //
// ./src/components/invoice/InvoiceListItem.jsx